import Vue from 'vue';
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push //避免路由重复报错
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter); //挂载属性

//创建路由对象并配置路由规则
let router = new VueRouter({
  mode: 'history',
  routes: [
      //一个个对象
      { path: '/', name: '重定向首页',redirect: '/home' },
      {
        path: '/home',
        name: '首页',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/home'),
      },
      {
        path: '/products/:id',
        name: '核心产品',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/products'),
      },
      {
        path: '/pro_zhwl/:id',
        name: '核心产品详情',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/pro_zhwl'),
      },
      {
        path: '/solutions/:id',
        name: '解决方案详情',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/solutions'),
      },
      {
        path: '/solutions_old/:id',
        name: '解决方案详情旧版',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/solutions_old'),
      },
      {
        path: '/hardware/:id',
        name: '硬件产品详情',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/hardware'),
      },
      {
        path: '/hardware_old/:id',
        name: '硬件产品详情旧版',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/hardware_old'),
      },
      {
        path: '/case',
        name: '项目案例',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/case'),
      },
      {
        path: '/caseDetail/:id',
        name: '项目案例详情',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/caseDetail'),
      },
      {
        path: '/aboutUs',
        name: '关于我们',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/aboutUs'),
      },
      {
        path: '/contactUs',
        name: '联系我们',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/contactUs'),
      },
      {
        path: '/water-recognition',
        name: '算法商城',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/ImageRecognition'),
      },
      {
        path: '/algorithm-detail/:name',
        name: '算法详情',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/AlgorithmDetail'),
      },
      {
        path: '/knowledge-qa',
        name: 'AI知识库问答',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/KnowledgeQA'),
      },
      {
        path: '/data-quality',
        name: '数据质量分析',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/DataQuality'),
      },
      {
        path: '/material-review',
        name: '行政材料审查',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/MaterialReview'),
      },
      {
        path: '/product-apply',
        name: '申请产品体验',
        component: () =>
          import( /* webpackChunkName: "page" */ '@/views/ProductApply'),
      },
  ],

  // 👇 每次路由切换都回到顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果使用浏览器前进/后退按钮，保持之前的滚动位置
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
});

// 预渲染就绪信号：等异步路由组件挂载并完成首次渲染后再置位，供 scripts/prerender.js 等待。
// 不能放在 App.vue 的 mounted 里——那时异步 chunk 还没加载，DOM 仍是空的。
window.__APP_READY__ = false
router.beforeEach((to, from, next) => {
  window.__APP_READY__ = false
  next()
})
router.afterEach(() => {
  // afterEach 触发时路由已更新但 DOM 尚未 patch，故等一次 nextTick + 两帧
  Vue.nextTick(() => {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      window.__APP_READY__ = true
    }))
  })
})

export default router;